module.exports = __webpack_public_path__ + "media/images/application/image-custom-wysiwyg-e7911a40e584831d2f55b0a7a85a4593.svg";